// es — checkin/quickCheck/stepTracker blocks translated.
export const es = {
  "common": {
    "loading": "Cargando…",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "back": "Atrás",
    "next": "Siguiente",
    "submit": "Enviar",
    "search": "Buscar",
    "select": "Seleccionar",
    "or": "O",
    "and": "y",
    "note": "Nota",
    "viewAll": "Ver todo",
    "learnMore": "Saber más",
    "getStarted": "Comenzar",
    "continue": "Continuar",
    "saving": "Guardando…"
  },
  "offline": {
    "banner": "Estás sin conexión. Algunas funciones pueden estar limitadas.",
    "savedLocally": "Guardado sin conexión — se sincronizará cuando vuelvas",
    "syncing": "Sincronizando tus actualizaciones…",
    "backOnline": "De vuelta en línea — actualizaciones sincronizadas"
  },

  "nav": {
    "dashboard": "Panel",
    "nutrition": "Nutrición inteligente",
    "family": "Familia",
    "care": "Servicios",
    "careShort": "Servicios",
    "checkIn": "Registro diario",
    "insights": "Análisis",
    "trends": "Tendencias",
    "habits": "Hábitos",
    "medications": "Medicamentos",
    "expertSupport": "Asesoría experta",
    "profile": "Perfil",
    "healthHub": "Centro de salud",
    "support": "Ayuda y soporte",
    "wellness": "Bienestar",
    "education": "Educación",
    "community": "Comunidad",
    "preventiveHealth": "Salud preventiva",
    "womensHealth": "Salud femenina",
    "reminders": "Recordatorios",
    "meals": "Comidas",
    "orders": "Pedidos",
    "subscription": "Suscripción",
    "logout": "Cerrar sesión"
  },

  "navShort": {
    "dashboard": "Inicio",
    "nutrition": "Nutrición",
    "family": "Familia",
    "care": "Servicios",
    "support": "Ayuda",
    "profile": "Perfil"
  },
  "auth": {
    "login": "Iniciar sesión",
    "register": "Crear cuenta",
    "logout": "Cerrar sesión",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "name": "Nombre completo",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "noAccount": "¿No tienes cuenta?",
    "haveAccount": "¿Ya tienes una cuenta?",
    "signInHere": "Inicia sesión aquí",
    "signUpHere": "Regístrate aquí",
    "welcomeBack": "¡Bienvenido(a) de nuevo!",
    "getStarted": "Comencemos",
    "biometricLogin": "Iniciar con Biometría",
    "biometricHelper": "Usa huella digital, Face ID o Windows Hello",
    "vendorLogin": "Acceso de Proveedor",
    "createOne": "Crear cuenta",
    "tagline": "Cuida tu salud — un sencillo registro cada día.",
    "takes30s": "Menos de 30 segundos",
    "emailPlaceholder": "tu@ejemplo.com",
    "passwordPlaceholder": "Tu contraseña",
    "checking": "Verificando…",
    "continue": "Continuar",
    "secureMessage": "Seguro y privado — tus datos están protegidos",
    "biometricSoon": "Acceso biométrico — Próximamente",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "vendor": {
      "title": "Acceso para Socios Comerciales",
      "subtitle": "Accede a tu panel de control de HealthLoop",
      "businessEmail": "Correo electrónico corporativo",
      "emailPlaceholder": "socio@empresa.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Iniciando sesión...",
      "signIn": "Iniciar sesión",
      "notVendorYet": "¿Aún no eres socio comercial?",
      "registerBusiness": "Registra tu empresa",
      "areYouUser": "¿Eres usuario?",
      "userLogin": "Inicio de sesión de usuario",
      "welcomeBackToast": "¡Te damos la bienvenida de nuevo!",
      "genericError": "Error al iniciar sesión. Inténtalo de nuevo."
    },
    "admin": {
      "backToUserLogin": "Inicio de sesión de usuario",
      "title": "Acceso de Administrador",
      "restrictedBadge": "Restringido",
      "tagline": "Consola de operador de HealthLoop — se requieren credenciales de administrador.",
      "emailLabel": "Correo de administrador",
      "emailPlaceholder": "admin@tudominio.com",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Introduce tu contraseña de administrador",
      "signingIn": "Iniciando sesión...",
      "submit": "Entrar a la consola de administración",
      "secureNote": "Conexión segura · sesión cifrada",
      "restrictedTitle": "Esta área está restringida a administradores.",
      "restrictedBody": "Has iniciado sesión, pero tu cuenta no tiene permisos de administrador. Cierra la sesión para probar con otra cuenta o regresa a la aplicación principal.",
      "signOut": "Cerrar sesión",
      "backToApp": "Volver a la aplicación"
    }
  },
  "quickCheck": {
    "header": {
      "title": "¿Cómo te sientes hoy?",
      "subtitle": "Control rápido — toma menos de 60 segundos"
    },
    "section1": {
      "title": "¿Qué notas hoy?",
      "hint": "(Selecciona todo lo que corresponda)"
    },
    "environment": {
      "title": "Tu entorno hoy",
      "hint": "Ayúdanos a entender lo que te rodea"
    },
    "basicChecks": {
      "title": "Controles básicos rápidos",
      "hint": "Opcional pero útil"
    },
    "validation": {
      "pickOne": "Por favor, responde al menos una pregunta"
    },
    "submit": {
      "cta": "Obtener mi guía de salud",
      "saving": "Guardando...",
      "analyzing": "Analizando tus patrones de salud...",
      "savedToast": "✅ ¡Control guardado! Analizando tus patrones de salud..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Seguimiento de pasos",
      "subtitle": "Registro de actividad honesto y privado",
      "backToDashboard": "Volver al panel"
    },
    "today": {
      "title": "Pasos de hoy",
      "goalProgress": "{{current}} / {{goal}} pasos",
      "goalReached": "¡Meta alcanzada, buen trabajo!",
      "keepGoing": "Sigue así, vas por buen camino."
    },
    "streak": {
      "label": "Racha actual",
      "days": "{{count}} día",
      "daysPlural": "{{count}} días"
    },
    "badges": {
      "title": "Insignias",
      "empty": "Ganarás insignias a medida que crees el hábito."
    },
    "reminders": {
      "title": "Recordatorios de movimiento",
      "hint": "Avisos suaves para caminar un poco si pasas mucho tiempo sentado.",
      "enabled": "Activado",
      "disabled": "Desactivado"
    },
    "insights": {
      "weeklyAverage": "Promedio semanal",
      "weeklyGoal": "Meta semanal"
    },
    "actions": {
      "connect": "Conectar fuente de pasos",
      "manualLog": "Registrar pasos manualmente",
      "changeGoal": "Cambiar meta diaria"
    },
    "offline": {
      "title": "Modo sin conexión activo",
      "body": "El seguimiento continúa incluso sin conexión. Sincronizaremos tus actualizaciones cuando vuelvas a conectarte."
    },
    "permission": {
      "title": "Conecta para el seguimiento automático de pasos",
      "body": "Permite que HealthLoop lea tus datos de {{platform}}. Tus datos de bienestar permanecen en tu dispositivo a menos que decidas sincronizarlos.",
      "connect": "Conectar",
      "maybeLater": "Quizás más tarde"
    },
    "sync": {
      "lastSynced": "Última sincronización {{time}}",
      "queued": "{{count}} actualización en cola para sincronizar.",
      "queuedPlural": "{{count}} actualizaciones en cola para sincronizar.",
      "disconnect": "Desconectar",
      "refreshAria": "Actualizar sincronización"
    },
    "progress": {
      "title": "Tu progreso de hoy",
      "stepsToday": "pasos hoy",
      "goalLabel": "Meta: {{goal}}",
      "stepsToGo": "Faltan {{remaining}} pasos",
      "goalAchieved": "🎉 Meta alcanzada",
      "goalAriaLabel": "Meta alcanzada",
      "statGoal": "Meta",
      "statProgress": "Progreso",
      "statSource": "Fuente",
      "sourceDevice": "Dispositivo",
      "sourceManual": "Manual"
    },
    "empty": {
      "waiting": "Esperando datos de actividad",
      "startMoving": "Empieza a moverte para comenzar el seguimiento",
      "shortWalkHint": "Da un paseo corto para probar el seguimiento — o registra una entrada manual abajo."
    },
    "manual": {
      "title": "Registrar pasos manualmente",
      "placeholder": "Ingresa pasos",
      "submit": "Registrar",
      "footer": "Las entradas manuales reemplazan el conteo de hoy. Se sincronizan automáticamente cuando estés en línea."
    },
    "trust": {
      "title": "Privado por defecto",
      "itemData": "Tus datos de bienestar permanecen en tu dispositivo a menos que los sincronices con tu cuenta.",
      "itemOffline": "El seguimiento continúa sin conexión — las actualizaciones se ponen en cola y se sincronizan al reconectar.",
      "itemNoInvent": "Nunca inventamos pasos. Solo guardamos valores de tu dispositivo o tus entradas manuales."
    },
    "howItWorks": {
      "title": "Cómo funciona",
      "itemConnect": "Conecta la app de salud de tu dispositivo para un seguimiento sin manos.",
      "itemManual": "La entrada manual siempre está disponible como respaldo confiable.",
      "itemOfflineQueue": "Las actualizaciones sin conexión se ponen en cola localmente y se sincronizan al volver en línea.",
      "itemDisconnect": "Desconéctate cuando quieras — tu historial registrado permanece en este dispositivo."
    }
  },
  "checkin": {
    "header": {
      "title": "Control diario de salud",
      "subtitle": "Toma menos de 60 segundos",
      "restDayLink": "Hoy no me apetece"
    },
    "snapshot": {
      "title": "Tu panel, actualizado",
      "healthScore": "Puntuación de salud",
      "todayTasks": "Tareas de hoy",
      "dayStreak": "días de racha"
    },
    "resume": {
      "banner": "Retomaste donde lo dejaste",
      "startFresh": "Empezar de cero",
      "dismiss": "Descartar"
    },
    "progress": {
      "allSet": "Todo listo",
      "step": "Paso {{current}} de {{total}}",
      "ariaLabel": "Progreso del control diario: {{done}} de {{total}} secciones completadas"
    },
    "insights": {
      "title": "Tus guías de salud",
      "subtitle": "Personalizadas para ti hoy",
      "insightForYou": "Guía para ti",
      "simpleActions": "Acciones sencillas que puedes tomar",
      "whenToSeekHelp": "Cuándo buscar ayuda",
      "nhsAdvice": "Si tienes inquietudes, contacta a tu médico de cabecera",
      "backToDashboard": "Volver al Panel",
      "newCheckIn": "Nuevo Control",
      "disclaimer": "HealthLoop ofrece orientación, no diagnósticos."
    },
    "restDay": {
      "title": "El descanso es parte del ritmo.",
      "body": "Estaremos aquí mañana, cuando tú lo estés.",
      "streakNote": "Tu racha no se ha movido — también está descansando.",
      "backToDashboard": "Volver al panel",
      "changedMind": "En realidad, me gustaría hacer el control ahora."
    },
    "feelings": {
      "title": "¿Cómo te sientes hoy?",
      "hint": "Selecciona todo lo que corresponda",
      "tired": "Me siento con cansancio",
      "headache": "Dolor de cabeza",
      "stressed": "Estrés o agobio",
      "pain": "Dolores o molestias corporales",
      "okay": "Me siento bien hoy"
    },
    "basics": {
      "title": "Tus básicos",
      "sleepQ": "¿Dormiste bien anoche?",
      "waterQ": "¿Has bebido suficiente agua hoy?",
      "foodQ": "¿Has comido adecuadamente hoy?",
      "activityQ": "¿Qué tan activo/a estuviste hoy?",
      "yes": "Sí",
      "notReally": "No mucho",
      "notYet": "Aún no",
      "notActive": "Nada activo",
      "lightActivity": "Actividad ligera",
      "active": "Activo"
    },
    "mind": {
      "title": "Mente y energía",
      "stressQ": "¿Cómo está tu nivel de estrés hoy?",
      "moodQ": "¿Cómo está tu ánimo hoy?",
      "energyQ": "¿Cómo está tu nivel de energía hoy?",
      "low": "Bajo",
      "moderate": "Moderado",
      "high": "Alto",
      "neutral": "Neutral",
      "good": "Bueno",
      "okay": "Bien"
    },
    "day": {
      "title": "Tu día",
      "routineQ": "¿Seguiste tu rutina normal hoy?",
      "yes": "Sí",
      "no": "No"
    },
    "environment": {
      "title": "Tu entorno hoy",
      "describeQ": "¿Cómo describirías tu entorno?",
      "comfortable": "😊 Cómodo",
      "slightlyUncomfortable": "😐 Algo incómodo",
      "challenging": "😓 Difícil",
      "affectedQ": "¿Tu entorno afectó cómo te sientes?",
      "yes": "Sí",
      "no": "No",
      "exposureLabel": "Exposición (selecciona todo lo que corresponda)",
      "heat": "🌡️ Calor",
      "cold": "❄️ Frío",
      "noise": "🔊 Ruido",
      "dustSmoke": "💨 Polvo o humo",
      "crowded": "👥 Espacio concurrido",
      "none": "✅ Ninguna"
    },
    "submit": {
      "analyzing": "Analizando tus patrones de salud...",
      "cta": "Ver mis guías de salud"
    },
    "toast": {
      "savedFull": "¡Control guardado! Tu panel se ha actualizado.",
      "savedShort": "Control guardado."
    }
  },
  "onboarding": {
    "welcome": "Bienvenido(a)",
    "completeSetup": "Completar configuración",
    "stepProgress": "Paso {{step}} de {{total}}",
    "percentComplete": "{{percent}}% completado",
    "welcomeToast": "¡Bienvenido(a) a HealthLoop! Tu perfil está listo.",
    "errorAgeRange": "Selecciona tu rango de edad",
    "errorCountry": "Selecciona tu país",
    "errorGoal": "Selecciona tu objetivo principal de salud",
    "errorCuisine": "Selecciona al menos una preferencia culinaria",
    "errorGeneric": "No se pudo completar la configuración. Inténtalo de nuevo.",
    "step1Title": "¡Bienvenido(a) a HealthLoop! 👋",
    "step1Subtitle": "Personalicemos tu camino hacia la salud",
    "ageRangeLabel": "¿Cuál es tu rango de edad?",
    "genderLabel": "Género (opcional)",
    "gender_male": "Masculino",
    "gender_female": "Femenino",
    "gender_non-binary": "No binario",
    "gender_prefer_not_to_say": "Prefiero no decirlo",
    "step2Title": "¿Dónde vives? 🌍",
    "step2Subtitle": "Nos ayuda a recomendar comidas culturalmente apropiadas",
    "countryLabel": "Selecciona tu país",
    "country_uk": "Reino Unido",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenia",
    "country_south_africa": "Sudáfrica",
    "country_usa": "Estados Unidos",
    "country_canada": "Canadá",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Otro",
    "step3Title": "¿Cuál es tu objetivo principal? 🎯",
    "step3Subtitle": "Elige tu prioridad de salud",
    "additionalGoals": "¿Otros objetivos? (opcional)",
    "goal_weight_loss": "Pérdida de peso",
    "goalDesc_weight_loss": "Bajar de peso sanamente",
    "goal_weight_maintenance": "Mantener peso",
    "goalDesc_weight_maintenance": "Mantenerte en tu peso actual",
    "goal_muscle_gain": "Ganar músculo",
    "goalDesc_muscle_gain": "Aumentar fuerza y músculo",
    "goal_general_wellness": "Bienestar general",
    "goalDesc_general_wellness": "Mejora general de salud",
    "goal_better_sleep": "Dormir mejor",
    "goalDesc_better_sleep": "Mejorar la calidad del sueño",
    "goal_reduce_stress": "Reducir estrés",
    "goalDesc_reduce_stress": "Gestionar mejor el estrés",
    "goal_increase_energy": "Más energía",
    "goalDesc_increase_energy": "Sentirte con más energía",
    "step4Title": "Preferencias alimentarias 🍽️",
    "step4Subtitle": "Cocinas favoritas y restricciones alimentarias",
    "cuisineLabel": "Cocinas preferidas",
    "cuisineHint": "Selecciona al menos una (puedes elegir varias)",
    "dietaryLabel": "Restricciones alimentarias (opcional)",
    "diet_vegetarian": "Vegetariano",
    "diet_vegan": "Vegano",
    "diet_halal": "Halal",
    "diet_kosher": "Kósher",
    "diet_gluten_free": "Sin gluten",
    "diet_dairy_free": "Sin lácteos",
    "diet_pescatarian": "Pescetariano",
    "step5Title": "Condiciones de salud 🏥",
    "step5Subtitle": "Opcional — nos ayuda a recomendar mejor",
    "conditionsLabel": "¿Tienes alguna de estas condiciones?",
    "conditionsHint": "Esta información es privada y sirve para personalizar tu experiencia",
    "condition_diabetes": "Diabetes",
    "condition_hypertension": "Hipertensión",
    "condition_heart_disease": "Enfermedad cardíaca",
    "condition_thyroid": "Problemas de tiroides",
    "condition_celiac": "Enfermedad celíaca",
    "condition_ibs": "Colon irritable",
    "condition_none": "Ninguna",
    "privacyTitle": "Tus datos están protegidos",
    "privacyBody": "Tu información personal se cifra y almacena de forma segura. La usamos solo para personalizar tu experiencia con recomendaciones de comidas, consejos de salud y notificaciones a tu medida. Tus datos nunca se compartirán con terceros sin tu consentimiento explícito.",
    "trackMedication": "Quiero registrar mis medicamentos",
    "specialistInterest": "Me interesan las consultas con especialistas",
    "welcomeTitle": "¡Te damos la bienvenida a HealthLoop! 👋",
    "welcomeSubtitle": "Personalicemos tu inteligencia de bienestar preventivo y estilo de vida con IA en unos simples pasos",
    "stepLabel": "Paso {{current}} de {{total}}",
    "skipForNow": "Omitir por ahora",
    "skipToast": "Puedes completar tu perfil en cualquier momento desde tu configuración",
    "back": "Atrás",
    "next": "Siguiente",
    "completing": "Finalizando...",
    "complete": "Completar configuración",
    "successToast": "¡Te damos la bienvenida a HealthLoop! Tu perfil ya está personalizado 🎉",
    "failureToast": "No se pudo completar el registro",
    "validation": {
      "basicInfo": "Por favor, completa toda la información básica",
      "pickGoal": "Por favor, selecciona al menos una meta de salud",
      "pickPrimary": "Por favor, selecciona tu meta principal",
      "pickRegion": "Por favor, selecciona tu región cultural para sugerencias de comidas personalizadas",
      "pickFocus": "Por favor, selecciona tu enfoque principal de bienestar"
    },
    "step1": {
      "title": "Tu Perfil de Salud",
      "description": "Ayúdanos a construir tu inteligencia de bienestar personalizada con IA",
      "age": "Edad *",
      "agePlaceholder": "ej. 30",
      "height": "Estatura (cm) *",
      "heightPlaceholder": "ej. 170",
      "weight": "Peso (kg) *",
      "weightPlaceholder": "ej. 70"
    },
    "step2": {
      "title": "Tus Metas de Salud",
      "description": "Selecciona todas las que apliquen y luego elige tu meta principal",
      "primaryLabel": "Selecciona tu Meta Principal *",
      "primaryBadge": "Principal"
    },
    "step3": {
      "title": "🌍 Preferencias Culturales y Comida",
      "description": "Ayúdanos a personalizar tus recomendaciones de comidas",
      "regionLabel": "Región Cultural *",
      "regionHint": "Selecciona tu origen cultural para recibir sugerencias de platos personalizados",
      "countryLabel": "País (Opcional)",
      "countryPlaceholder": "ej. Nigeria, Kenia, Jamaica",
      "countryHint": "Para obtener recomendaciones aún más precisas",
      "foodPrefLabel": "Preferencia de Diversidad Alimentaria"
    },
    "step4": {
      "title": "Enfoque Principal de Bienestar",
      "description": "Elige el área en la que más deseas enfocarte"
    },
    "step5": {
      "title": "Tus Preferencias",
      "description": "Personaliza tu experiencia en HealthLoop",
      "trackMeds": "Seguimiento de Medicación",
      "trackMedsHint": "Activa el registro y recordatorios de medicamentos en tus chequeos diarios",
      "specialist": "Interés en Apoyo de Especialistas",
      "specialistHint": "Obtén acceso a especialistas en bienestar, nutricionistas y profesionales de la salud emocional",
      "confidentialTitle": "Apoyo Confidencial:",
      "confidentialBody": "Toda tu información está protegida y se utiliza exclusivamente para brindarte recomendaciones de salud preventiva personalizadas."
    },
    "step6": {
      "title": "Personalización de Comidas",
      "description": "Ayúdanos a recomendarte platos que se ajusten a tus gustos y necesidades",
      "cuisinesLabel": "Cocinas Preferidas (Opcional)",
      "cuisinesHint": "Selecciona los tipos de cocina que más disfrutas",
      "dietaryLabel": "Restricciones Alimentarias (Opcional)",
      "dietaryHint": "Selecciona las que apliquen en tu caso",
      "allergiesLabel": "Alergias Comunes (Opcional)",
      "allergiesHint": "Selecciona cualquier alergia alimentaria",
      "personalisedTitle": "Comidas Personalizadas:",
      "personalisedBody": "Usaremos estas preferencias para recomendarte platos que se adapten a tu paladar. Puedes cambiar esto más adelante en Configuración."
    },
    "healthGoals": {
      "better_sleep": "Dormir mejor",
      "reduce_stress": "Menos estrés",
      "increase_energy": "Más energía",
      "weight_management": "Control de peso",
      "improve_fitness": "Mejorar condición física",
      "better_nutrition": "Mejor nutrición",
      "mental_wellness": "Bienestar emocional",
      "chronic_condition": "Gestionar condición crónica"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Salud Emocional",
        "description": "Enfoque en el ánimo, estrés y bienestar psicológico"
      },
      "physical_fitness": {
        "label": "Condición Física",
        "description": "Enfoque en el ejercicio, fuerza y actividad"
      },
      "nutrition": {
        "label": "Nutrición",
        "description": "Enfoque en la dieta, comidas y alimentación sana"
      },
      "sleep": {
        "label": "Calidad del Sueño",
        "description": "Enfoque en el descanso, patrones de sueño y recuperación"
      },
      "stress_management": {
        "label": "Manejo del Estrés",
        "description": "Enfoque en la relajación y reducción de tensión"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "África Occidental",
        "description": "Cocina de Nigeria, Ghana, Senegal"
      },
      "east_african": {
        "label": "África Oriental",
        "description": "Cocina de Kenia, Etiopía, Tanzania"
      },
      "north_african": {
        "label": "África del Norte",
        "description": "Cocina de Marruecos, Egipto"
      },
      "southern_african": {
        "label": "África del Sur",
        "description": "Cocina de Sudáfrica"
      },
      "caribbean": {
        "label": "Caribeña",
        "description": "Cocina de Jamaica, Trinidad, Barbados"
      },
      "middle_eastern": {
        "label": "Medio Oriente",
        "description": "Cocina de Líbano, Palestina, Siria"
      },
      "south_asian": {
        "label": "Asia del Sur",
        "description": "Cocina de India, Pakistán, Bangladesh"
      },
      "east_asian": {
        "label": "Asia Oriental",
        "description": "Cocina de China, Japón, Corea"
      },
      "southeast_asian": {
        "label": "Sudeste Asiático",
        "description": "Cocina de Tailandia, Vietnam, Indonesia"
      },
      "western": {
        "label": "Occidental",
        "description": "Cocina de Estados Unidos, Europa"
      },
      "latin_american": {
        "label": "Latinoamericana",
        "description": "Cocina de México, Brasil, Argentina"
      },
      "mediterranean": {
        "label": "Mediterránea",
        "description": "Cocina de Grecia, Italia, España"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Tradicional",
        "description": "Principalmente platos de tu región cultural"
      },
      "mixed": {
        "label": "Mixta",
        "description": "Equilibrio entre cocina local e internacional"
      },
      "international": {
        "label": "Internacional",
        "description": "Diversas cocinas del mundo"
      }
    },
    "cuisines": {
      "west_african": "África Occidental",
      "caribbean": "Caribeña",
      "mediterranean": "Mediterránea",
      "asian": "Asiática",
      "western": "Occidental",
      "indian": "India",
      "middle_eastern": "Medio Oriente",
      "general": "Todas las cocinas"
    },
    "dietary": {
      "vegetarian": "Vegetariana",
      "vegan": "Vegana",
      "pescatarian": "Pesquetariana",
      "gluten_free": "Sin Gluten",
      "dairy_free": "Sin Lácteos",
      "low_carb": "Baja en Carbohidratos"
    },
    "allergies": {
      "nuts": "Frutos Secos",
      "shellfish": "Mariscos",
      "dairy": "Lácteos",
      "eggs": "Huevos",
      "soy": "Soya",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nigeriana",
    "cuisine_ghanaian": "Ghanesa",
    "cuisine_senegalese": "Senegalesa",
    "cuisine_kenyan": "Keniata",
    "cuisine_ethiopian": "Etíope",
    "cuisine_moroccan": "Marroquí",
    "cuisine_south_african": "Sudafricana",
    "cuisine_jamaican": "Jamaiquina",
    "cuisine_trinidadian": "Trinitense",
    "cuisine_lebanese": "Libanesa",
    "cuisine_turkish": "Turca",
    "cuisine_greek": "Griega",
    "cuisine_italian": "Italiana",
    "cuisine_french": "Francesa",
    "cuisine_british": "Británica",
    "cuisine_indian_south": "India del sur",
    "cuisine_indian_north": "India del norte",
    "cuisine_pakistani": "Pakistaní",
    "cuisine_japanese": "Japonesa",
    "cuisine_chinese": "China",
    "cuisine_korean": "Coreana",
    "cuisine_vietnamese": "Vietnamita",
    "cuisine_thai": "Tailandesa",
    "cuisine_filipino": "Filipina",
    "cuisine_american": "Estadounidense",
    "cuisine_mexican": "Mexicana",
    "cuisine_brazilian": "Brasileña",
    "cuisine_peruvian": "Peruana"
  },
  "dashboard": {
    "welcome": "Bienvenido(a) de nuevo",
    "greeting": "Hola",
    "goodMorning": "Buenos días",
    "goodAfternoon": "Buenas tardes",
    "goodEvening": "Buenas noches",
    "tagline": "Pequeños pasos saludables crean un cambio duradero",
    "microcopy": "Tu camino hacia el bienestar importa.",
    "welcomeSubtitleMorning1": "Un comienzo tranquilo para el día.",
    "welcomeSubtitleMorning2": "Nos alegra verte esta mañana.",
    "welcomeSubtitleMorning3": "Los pequeños momentos suman.",
    "welcomeSubtitleAfternoon1": "Que tu día se sienta estable.",
    "welcomeSubtitleAfternoon2": "Bienvenido(a) a HealthLoop.",
    "welcomeSubtitleAfternoon3": "Respira — vas muy bien.",
    "welcomeSubtitleEvening1": "Cerrando el día contigo.",
    "welcomeSubtitleEvening2": "Un cierre suave del día.",
    "welcomeSubtitleEvening3": "Bienvenido(a) esta noche.",
    "title": "Tu plataforma de salud preventiva",
    "subtitle": "Monitorea, aprende y actúa antes de que los problemas crezcan",
    "summary": "Resumen de tu salud",
    "summaryDesc": "Perspectivas en tiempo real sobre prevención, educación, compromiso y bienestar",
    "comprehensiveSupport": "Soporte integral en prevención, educación, compromiso y bienestar",
    "todayCheckIn": "Registro de hoy",
    "quickActions": "Acciones rápidas",
    "healthOverview": "Resumen de salud",
    "recentActivity": "Actividad Reciente",
    "viewAll": "Ver todo",
    "preventiveHealth": "Salud preventiva",
    "preventiveHealthDesc": "Seguimiento diario, monitoreo de bienestar y alertas preventivas",
    "education": "Educación",
    "educationDesc": "Perspectivas basadas en evidencia, artículos de salud y orientación experta",
    "engagement": "Participación",
    "engagementDesc": "Desafíos comunitarios, seguimiento de hábitos y apoyo social",
    "wellness": "Bienestar",
    "wellnessDesc": "Nutrición inteligente, equilibrio de estilo de vida y bienestar holístico",
    "todaysInsight": "Idea del día",
    "wellnessScore": "Puntaje de bienestar",
    "healthStreak": "Racha saludable",
    "days": "días",
    "logHealth": "Registrar salud",
    "getEducated": "Aprender",
    "communityChallenge": "Desafío Comunitario",
    "checkWellness": "Revisar bienestar",
    "verified": "Verificado",
    "joinCommunity": "Unirse a la Comunidad",
    "personalizedPlan": "Plan personalizado",
    "score": "Puntaje",
    "checkIns": "registros",
    "habits": "hábitos",
    "preventive": "Preventivo",
    "healthMetrics": "Métricas de Salud",
    "trackMetrics": "Rastrear Métricas",
    "startTracking": "Comenzar a rastrear",
    "logMetrics": "Registrar Métricas",
    "dailyInsight": "Perspectiva Diaria",
    "learnAbout": "Aprende sobre salud preventiva hoy",
    "articlesAvailable": "artículos disponibles",
    "browseArticles": "Explorar Artículos",
    "currentStreak": "Racha Actual",
    "keepGoing": "¡Sigue así!",
    "startStreak": "Comienza tu racha",
    "checkIn": "Registrarse",
    "nutritionPlan": "Plan de Nutrición",
    "mealsPlanned": "comidas planificadas",
    "viewPlan": "Ver Plan",
    "planYourWeek": "Planifica tu semana",
    "moodStress": "Ánimo y estrés",
    "howFeeling": "¿Cómo te sientes?",
    "logWellness": "Registrar Bienestar",
    "medications": "Medicamentos",
    "noMeds": "No hay medicamentos rastreados",
    "addMedications": "Agregar medicamentos",
    "daysTracked": "Días Rastreados",
    "noHabits": "No hay hábitos aún",
    "startTrackingHabits": "Comenzar a rastrear hábitos",
    "insights": "Perspectivas",
    "noInsights": "No hay perspectivas aún",
    "completeFirstPlan": "Completa tu primer plan",
    "noCheckIns": "No hay registros aún",
    "startFirstCheckIn": "Comienza tu primer registro"
  },
  "support": {
    "title": "Soporte",
    "subtitle": "Encuentra respuestas, contáctanos o reporta un problema",
    "backToSettings": "Volver a ajustes",
    "privacyBanner": "Las solicitudes de soporte se gestionan de forma privada y segura. Tu información de salud permanece confidencial.",
    "section1": "Sección 1",
    "section2": "Sección 2",
    "section3": "Sección 3",
    "section4": "Sección 4",
    "navHelpCenter": "Centro de ayuda",
    "navContact": "Contactar soporte",
    "navHealth": "Servicios de salud",
    "navTechnical": "Soporte técnico",
    "helpCenterTitle": "Centro de ayuda",
    "helpCenterSubtitle": "Busca preguntas frecuentes y encuentra respuestas rápidas.",
    "contactTitle": "Contactar soporte",
    "contactSubtitle": "Elige tu canal preferido para contactar al equipo.",
    "healthServicesTitle": "Servicios de salud",
    "healthServicesSubtitle": "Accede al seguimiento de medicamentos y a expertos clínicos.",
    "technicalTitle": "Soporte técnico",
    "technicalSubtitle": "Reporta errores o problemas técnicos con contexto detallado.",
    "searchPlaceholder": "Buscar preguntas frecuentes…",
    "liveChat": "Chat en vivo",
    "emailUs": "Escríbenos",
    "callBack": "Schedule a callback",
    "sendMessage": "Enviar mensaje",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Tu nombre",
    "yourEmail": "Tu correo",
    "subject": "Asunto",
    "message": "Mensaje",
    "phone": "Phone",
    "description": "Description",
    "submit": "Enviar",
    "successTitle": "Mensaje enviado",
    "successDescription": "Responderemos en 24–48 horas.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "Nutrición inteligente",
    "basedOnGoal": "Según tu objetivo:",
    "personalizedData": "Personalizado según tus datos de salud recientes",
    "evidenceBased": "Nutrición basada en evidencia como parte de tu plan de salud preventiva",
    "todaysMealSuggestions": "Sugerencias de comidas para hoy",
    "customize": "Personalizar",
    "breakfast": "Desayuno",
    "lunch": "Almuerzo",
    "dinner": "Cena",
    "loadingBreakfast": "Cargando desayuno...",
    "loadingLunch": "Cargando almuerzo...",
    "loadingDinner": "Cargando cena...",
    "cal": "cal",
    "protein": "proteína",
    "swapMeal": "Cambiar comida",
    "healthyOptionsNearYou": "Opciones saludables cerca de ti",
    "enableLocation": "Activar ubicación",
    "view": "Ver",
    "discoverOptions": "Descubre restaurantes saludables, tiendas de comestibles y proveedores de comidas cerca de ti",
    "cuisinesSelected": "cocinas seleccionadas",
    "cuisineSelected": "cocina seleccionada",
    "dietaryPrefs": "preferencias dietéticas",
    "dietaryPref": "preferencia dietética",
    "customizeMeals": "Personalizar comidas",
    "subtitleAdaptive": "Planificación de comidas culturalmente adaptada a tus objetivos de salud",
    "hideFavorites": "Ocultar favoritos",
    "viewFavorites": "Ver favoritos",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "Ver plan completo",
    "exploreRecipes": "Explorar recetas"
  },
  "location": {
    "permissionTitle": "Encuentra opciones saludables cerca de ti",
    "permissionDesc": "Se usa para recomendar restaurantes, tiendas de comestibles y proveedores de comidas alineados con tus objetivos de salud.",
    "howToEnable": "Cómo habilitar:",
    "step1": "Haz clic en el icono de candado 🔒 en la barra de direcciones",
    "step2": "Busca permisos de \"Ubicación\"",
    "step3": "Cambia a \"Permitir\"",
    "step4": "Actualiza esta página",
    "refreshPage": "Actualizar Página",
    "allowLocation": "Permitir Ubicación",
    "notNow": "Ahora no",
    "denied": "El acceso a la ubicación fue bloqueado. Para ver opciones saludables cercanas, necesitarás habilitar los permisos de ubicación.",
    "unavailable": "La información de ubicación no está disponible actualmente. Por favor, verifica la configuración de tu dispositivo.",
    "error": "No se puede acceder a tu ubicación. Por favor, intenta de nuevo o verifica la configuración del navegador.",
    "unsupported": "Tu navegador no admite servicios de ubicación. Intenta usar un navegador moderno como Chrome, Firefox o Safari.",
    "accessRequired": "Se Requiere Acceso a Ubicación"
  },
  "womensHealth": {
    "title": "Salud de la Mujer",
    "description": "Rastrea tu ciclo, registra síntomas y obtén consejos de bienestar personalizados según tu fase del ciclo",
    "cycleTracking": "Seguimiento del Ciclo",
    "symptomLogging": "Registro de Síntomas",
    "phaseInsights": "Perspectivas de Fase",
    "logPeriod": "Registrar Período",
    "logSymptoms": "Registrar Síntomas",
    "insights": "Perspectivas",
    "tips": "Consejos de Salud",
    "overview": "Resumen",
    "history": "Historial",
    "startTracking": "Comienza a Rastrear tu Ciclo"
  },
  "profile": {
    "title": "Perfil",
    "personalInfo": "Información personal",
    "healthProfile": "Perfil de salud",
    "preferences": "Preferencias",
    "language": "Idioma",
    "selectLanguage": "Seleccionar idioma",
    "notifications": "Notificaciones",
    "privacy": "Privacidad",
    "security": "Seguridad",
    "quickAccess": "Acceso rápido",
    "editProfile": "Editar perfil",
    "viewStats": "Ver estadísticas",
    "backToDashboard": "Volver al panel",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "Ayuda y soporte",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "Enviar comentarios",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "Reportar un problema",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Información básica",
    "fullName": "Nombre completo",
    "email": "Correo electrónico",
    "dateOfBirth": "Fecha de nacimiento",
    "gender": "Género",
    "height": "Estatura (cm)",
    "weight": "Peso (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Configuración",
    "general": "General",
    "account": "Cuenta",
    "appearance": "Apariencia",
    "languageSettings": "Configuración de Idioma",
    "changeLanguage": "Cambiar Idioma",
    "languageNote": "Algunos idiomas nuevos están traducidos por IA y a la espera de revisión por hablantes nativos.",
    "languageUpdated": "Idioma actualizado exitosamente",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Traducción automática; revisión profesional pendiente.",
    "regions": {
      "global": "Global",
      "european": "Idiomas europeos",
      "middleEastern": "Idiomas de Oriente Medio",
      "asian": "Idiomas asiáticos",
      "african": "Idiomas africanos"
    }
  },
  "search": {
    "triggerLabel": "Buscar en HealthLoop",
    "triggerHint": "Prueba con \"pasos\", \"farmacia\" o \"embarazo\"",
    "triggerAriaLabel": "Abrir búsqueda global",
    "placeholder": "Busca funciones, registros, soporte...",
    "inputAriaLabel": "Buscar funciones de HealthLoop",
    "modalAriaLabel": "Buscar en HealthLoop",
    "close": "Cerrar",
    "clear": "Borrar",
    "clearAriaLabel": "Borrar búsqueda",
    "recentSearches": "Búsquedas recientes",
    "tryFor": "Intenta buscar",
    "findFeatures": "Encuentra cualquier función en segundos.",
    "searchAcross": "Busca en",
    "and": "y",
    "sections": {
      "home": "Inicio",
      "nutrition": "Nutrición",
      "family": "Familia",
      "services": "Servicios",
      "support": "Soporte",
      "profile": "Perfil"
    },
    "noMatchesFor": "No hay resultados para \"{{query}}\"",
    "trySimpler": "Prueba con una palabra más sencilla como pasos, nutrición o especialista.",
    "comingSoonBadge": "Próximamente",
    "escToClose": "para cerrar",
    "resultSingular": "{{count}} resultado",
    "resultPlural": "{{count}} resultados",
    "searchAcrossApp": "Busca en toda la aplicación"
  },
  "familyMember": {
    "confirmRemove": "¿Eliminar a {{name}} del seguimiento de salud familiar?",
    "removed": "{{name}} fue eliminado/a de la familia",
    "removeFailed": "Error al eliminar al miembro",
    "viewDetails": "Ver detalles",
    "edit": "Editar",
    "remove": "Eliminar",
    "yearsSuffix": "años",
    "healthGoalsLabel": "Metas de bienestar:",
    "moreSuffix": "más",
    "activeInsights": "Sugerencias activas",
    "viewAllInsights": "Ver las {{count}} sugerencias →",
    "viewFullProfile": "Ver perfil de bienestar completo",
    "lifeStage": {
      "infant": "Bebé (0-2)",
      "toddler": "Infante (2-5)",
      "child": "Niño/a (6-12)",
      "adolescent": "Adolescente (13-17)",
      "adult": "Adulto (18-59)",
      "senior": "Adulto mayor (60+)",
      "unknown": "Desconocido"
    }
  },
  "profileDeep": {
    "backToDashboard": "Volver al panel",
    "profileCompletion": "Perfil completado",
    "healthSummary": "Resumen de salud",
    "sectionA": "Sección A",
    "sectionB": "Sección B",
    "sectionC": "Sección C",
    "sectionD": "Sección D",
    "personalDetails": "Datos personales",
    "healthInformation": "Información de salud",
    "accountSettings": "Ajustes de cuenta",
    "fullName": "Nombre completo",
    "email": "Correo electrónico",
    "dob": "Fecha de nacimiento",
    "gender": "Género",
    "genderPlaceholder": "ej. Femenino, Masculino, No binario",
    "height": "Estatura (cm)",
    "heightPlaceholder": "ej. 170",
    "weight": "Peso (kg)",
    "weightPlaceholder": "ej. 70",
    "allergies": "Alergias",
    "allergiesPlaceholder": "ej. Cacahuetes",
    "medicalConditions": "Condiciones médicas",
    "conditionsPlaceholder": "ej. Hipertensión",
    "medications": "Medicamentos",
    "medicationsPlaceholder": "ej. Lisinopril 10 mg, diario",
    "emergencyContact": "Contacto de emergencia",
    "emergencyOptional": "(opcional)",
    "emergencyPlaceholder": "ej. Mamá +34 600 000 000",
    "emergencyNote": "Solo se incluye al compartir con un médico si lo aceptas.",
    "saveChanges": "Guardar cambios",
    "saving": "Guardando…",
    "editProfile": "Editar perfil",
    "cancelEditing": "Cancelar edición",
    "healthScore": "Puntaje de salud",
    "streak": "Racha",
    "streakDays": "{{n}} días",
    "memberSince": "Miembro desde",
    "remindersActive": "Recordatorios activos",
    "conditionsTracked": "Condiciones registradas",
    "nextAgenda": "En tu agenda",
    "notificationsReminders": "Notificaciones y recordatorios",
    "notificationsRemindersDesc": "Gestiona horarios y canales de recordatorio",
    "emailNudges": "Avisos por correo",
    "emailNudgesDesc": "Recordatorios suaves y resúmenes semanales",
    "on": "Activos",
    "paused": "En pausa",
    "privacySecurity": "Privacidad y seguridad",
    "privacySecurityDesc": "Actualiza tu contraseña para mantener tu cuenta segura",
    "preferencesTitle": "Preferencias",
    "preferencesDesc": "Idioma, región y personalización",
    "supportHelp": "Ayuda y soporte",
    "supportHelpDesc": "Encuentra respuestas o contacta con soporte",
    "sectionAccount": "Cuenta",
    "sectionSupport": "Soporte",
    "sectionAbout": "Acerca de",
    "sectionAdmin": "Administrador",
    "privacyPolicy": "Política de privacidad",
    "terms": "Términos",
    "appVersion": "Versión de la app",
    "giveFeedback": "Enviar comentarios",
    "giveFeedbackDesc": "Cuéntanos qué mejorar",
    "reportProblem": "Reportar un problema",
    "reportProblemDesc": "¿Encontraste un error? Cuéntanos",
    "adminInsights": "Métricas admin",
    "adminInsightsDesc": "Analítica de participación",
    "adminBadge": "Admin",
    "shareWithClinician": "Compartir con un médico",
    "shareWithClinicianDesc": "Resumen de solo lectura · caduca automáticamente · revocable en cualquier momento",
    "share": "Compartir",
    "profileMayBeOutOfDate": "El perfil puede estar desactualizado",
    "profileMayBeOutOfDateDesc": "Mantén tus datos al día para recibir mejores consejos — pequeños cambios (peso, medicamentos) nos ayudan a personalizar tus recordatorios.",
    "updateNow": "Actualizar ahora",
    "profileUpdateError": "No se pudo actualizar tu preferencia. Inténtalo de nuevo.",
    "healthLoopUser": "Usuario de HealthLoop",
    "updatedLabel": "Actualizado",
    "noEntries": "Aún no hay entradas.",
    "completionComplete": "Tu perfil está completo. Podemos darte nuestra mejor orientación. 💚",
    "completionAlmostThere": "Casi listo. Unos detalles más para ideas más precisas.",
    "completionInProgress": "Completa tu perfil para mejores ideas de bienestar.",
    "justNow": "justo ahora",
    "minAgo": "hace {{n}} min",
    "minsAgo": "hace {{n}} min",
    "hourAgo": "hace {{n}} hora",
    "hoursAgo": "hace {{n}} horas",
    "dayAgo": "hace {{n}} día",
    "daysAgo": "hace {{n}} días",
    "checkinDueToday": "Chequeo pendiente hoy",
    "checkinDueTonight": "Chequeo pendiente esta noche"
  },
  "supportDeep": {
    "backToSettings": "Volver a ajustes",
    "quickNavAria": "Secciones de soporte",
    "searchPlaceholder": "Busca ayuda…",
    "searchAria": "Buscar en preguntas frecuentes",
    "resultsCount": "{{n}} resultado",
    "resultsCountPlural": "{{n}} resultados",
    "questionsCount": "{{n}} preguntas",
    "liveChatTitle": "Chat en vivo",
    "liveChatDesc": "Habla con nosotros en tiempo real · Lun–Vie 9h–18h",
    "startChat": "Iniciar chat",
    "liveChatSoonToast": "El chat en vivo está por llegar. Por ahora, el correo funciona muy bien.",
    "emailUsTitle": "Escríbenos",
    "emailUsDesc": "Respuesta en 24–48 horas",
    "copy": "Copiar",
    "emailCopied": "Correo copiado al portapapeles.",
    "contactFormTitle": "Formulario de contacto",
    "contactFormDesc": "Envíanos un mensaje — respondemos por correo.",
    "yourNameLabel": "Tu nombre *",
    "namePlaceholder": "Juana Pérez",
    "yourEmailLabel": "Tu correo *",
    "emailPlaceholder": "juana@ejemplo.com",
    "subjectOptional": "Asunto (opcional)",
    "subjectPlaceholder": "¿En qué podemos ayudar?",
    "messageLabel": "Mensaje *",
    "messagePlaceholder": "Cuéntanos brevemente qué necesitas.",
    "sending": "Enviando…",
    "sendMessage": "Enviar mensaje",
    "messageSent": "Mensaje enviado",
    "messageSentDesc": "Responderemos en 24–48 horas.",
    "callbackTitle": "Solicitar llamada",
    "callbackDesc": "Te llamamos cuando te venga bien.",
    "phoneLabel": "Teléfono *",
    "phonePlaceholder": "+34 600 000 000",
    "preferredTimeLabel": "Hora preferida (opcional)",
    "preferredTimePlaceholder": "ej. mañana por la tarde",
    "reasonLabel": "Motivo (opcional)",
    "reasonPlaceholder": "¿Sobre qué quieres hablar?",
    "submitting": "Enviando…",
    "requestCallback": "Solicitar llamada",
    "callbackRequested": "Llamada solicitada",
    "callbackRequestedDesc": "Te contactaremos en menos de 24 horas.",
    "medicationSupport": "Apoyo de medicación",
    "medicationSupportDesc": "Sigue recetas, recargas y recordatorios.",
    "goToMedications": "Ir a medicamentos →",
    "specialistConsultation": "Consulta con especialista",
    "specialistConsultationDesc": "Habla con un clínico para orientación personalizada.",
    "connectExpert": "Conectar con experto →",
    "videoConsult": "Videoconsulta",
    "videoConsultDesc": "Reserva una sesión por vídeo con un especialista.",
    "bookConsultation": "Reservar consulta →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop apoya tu bienestar diario — no sustituye la atención médica de urgencia. Ante una emergencia contacta los servicios locales.",
    "categoryLabel": "Categoría",
    "catBug": "Error / Bug",
    "catPerformance": "Rendimiento lento",
    "catFeature": "Función que no funciona",
    "catUi": "Problema visual",
    "catOther": "Otro",
    "issueTitle": "Título del problema *",
    "issueTitlePlaceholder": "Resumen breve",
    "detailedDescription": "Descripción detallada *",
    "detailedDescriptionPlaceholder": "¿Qué ocurrió? ¿Qué hacías? Los pasos para reproducirlo nos ayudan mucho.",
    "autoAttachNote": "Se adjuntan automáticamente la información del dispositivo, navegador y ventana.",
    "submitReport": "Enviar reporte",
    "reportSubmitted": "Reporte enviado",
    "reportSubmittedDesc": "Nuestro equipo lo revisará.",
    "fillAllFields": "Por favor completa todos los campos obligatorios",
    "problemReportSubmittedToast": "Reporte enviado. Lo revisaremos y te contactaremos.",
    "messageSentToast": "Mensaje enviado. Responderemos en 24–48 horas.",
    "callRequestedToast": "Llamada solicitada. Te contactamos en 24 horas.",
    "submitFailGeneric": "No se pudo enviar. Inténtalo otra vez o escribe a {{email}}.",
    "submitFailContact": "No se pudo enviar. Escribe directamente a {{email}}."
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "Perfil de salud",
    "notifications": "Notificaciones",
    "familyAccounts": "Cuentas familiares",
    "settings": "Ajustes",
    "logout": "Cerrar sesión",
    "allCaughtUp": "Estás al día.",
    "weekInReview": "Tu semana en resumen",
    "dismissNotification": "Descartar notificación",
    "dismissWeeklyDigest": "Descartar resumen semanal",
    "notificationsAria": "Notificaciones",
    "profileMenuAria": "Abrir menú de perfil",
    "loadingWellness": "Cargando tu resumen de bienestar",
    "nextTip": "Siguiente consejo",
    "todayAtGlance": "Hoy de un vistazo",
    "healthScoreLabel": "Puntaje de salud",
    "currentStreakLabel": "Racha actual",
    "todaysProgress": "Progreso de hoy",
    "insightForYou": "Una idea para ti",
    "checkMyHealthRisk": "Revisar mi riesgo de salud",
    "quickAccess": "Acceso rápido",
    "familyCare": "Cuidado familiar",
    "healthLibrary": "Biblioteca de salud",
    "myHealthData": "Mis datos de salud",
    "askQuestion": "Hacer una pregunta",
    "dashLoadError": "No pudimos cargar tu panel. Inténtalo otra vez.",
    "taskUpdateError": "No pudimos actualizar la tarea. Inténtalo otra vez.",
    "perfectDay": "¡Día perfecto! 🎉 Racha extendida.",
    "letsStart": "Vamos a empezar",
    "yourNextStepToday": "Tu siguiente paso hoy",
    "completeDailyCheck": "Completa tu chequeo diario de salud",
    "startDailyCheck": "Empezar chequeo diario",
    "viewAll": "Ver todo",
    "graceProtected": "Protección de gracia",
    "todaysHealthRecommendations": "Recomendaciones de salud de hoy",
    "updateViaCheck": "Actualizar con chequeo diario",
    "healthInsight": "Idea de salud",
    "riskCheckSubtext": "Obtén ideas de salud personalizadas en segundos",
    "foodDiet": "Comida y dieta",
    "healthScoreNew": "Puntaje de salud · Nuevo",
    "letsBuildScore": "Construyamos juntos tu puntaje de salud",
    "oneHealthyHabitAtATime": "Un hábito saludable a la vez.",
    "nextCheck": "Próximo chequeo:",
    "todayAt8pm": "hoy a las 20:00",
    "wellnessTipForYou": "Consejo de bienestar de hoy · Para ti",
    "wellnessTipForFactor": "Consejo de bienestar de hoy · Para tu {{factor}}",
    "logged": "Registrado",
    "gotIt": "Entendido 👍",
    "gladToSeeYou": "Nos alegra verte hoy 💚",
    "takesLessThan60Sec": "Menos de 60 segundos",
    "scoreReadyWhenYou": "Listos cuando tú lo estés",
    "scoreCompleteFirstCheck": "Completa tu primer chequeo para desbloquear ideas personalizadas.",
    "scoreExcellent": "Excelente",
    "scoreSupportExcellent": "Estás en un gran momento hoy. ¡Sigue así!",
    "scoreGood": "Bueno",
    "scoreSupportGood": "Lo estás haciendo bien. Mantén tus hábitos saludables.",
    "scoreModerate": "Moderado",
    "scoreSupportModerate": "Vas bien, pero algunas áreas necesitan atención.",
    "scoreNeedsAttention": "Necesita atención",
    "scoreSupportNeedsAttention": "Tu salud necesita atención hoy. Pequeños cambios pueden ayudar."
  },
  "emailVerify": {
    "bannerWithEmail": "Verifica tu correo ({{email}}) para mantener tu cuenta segura y recibir tus recordatorios.",
    "bannerNoEmail": "Verifica tu correo para mantener tu cuenta segura y recibir tus recordatorios.",
    "sending": "Enviando…",
    "resend": "Reenviar correo",
    "sentToast": "Correo de verificación enviado. Revisa tu bandeja.",
    "sendFailToast": "No se pudo enviar el correo. Inténtalo más tarde."
  },
  "forgotPassword": {
    "title": "¿Olvidaste tu contraseña?",
    "subtitle": "¡No te preocupes! Ingresa tu correo y te enviaremos las instrucciones.",
    "emailLabel": "Correo electrónico",
    "emailPlaceholder": "tu.correo@ejemplo.com",
    "sendResetLink": "Enviar enlace",
    "sending": "Enviando…",
    "backToLogin": "Volver al inicio de sesión",
    "resendLink": "Reenviar correo",
    "successTitle": "Revisa tu correo",
    "successBody": "Si existe una cuenta para {{email}}, te enviamos un enlace de restablecimiento.",
    "linkExpires": "El enlace expirará en 30 minutos.",
    "successToast": "Revisa tu correo para las instrucciones",
    "errEmptyEmail": "Ingresa tu correo electrónico",
    "errInvalidEmail": "Ingresa un correo válido",
    "errNetwork": "No se pudo contactar al servidor. Revisa tu conexión.",
    "errGeneric": "No se pudo enviar el correo. Inténtalo otra vez o contacta soporte."
  },
  "resetPassword": {
    "title": "Nueva contraseña",
    "subtitle": "Crea una contraseña segura para tu cuenta",
    "newPasswordLabel": "Nueva contraseña",
    "newPasswordPlaceholder": "Ingresa la nueva contraseña",
    "confirmPasswordLabel": "Confirmar contraseña",
    "confirmPasswordPlaceholder": "Confirma la nueva contraseña",
    "requirementsHint": "8 caracteres mínimo, con mayúscula, minúscula y número",
    "resetPassword": "Restablecer contraseña",
    "resetting": "Restableciendo…",
    "successTitle": "¡Contraseña restablecida!",
    "successBody": "Ahora puedes iniciar sesión con tu nueva contraseña.",
    "successToast": "¡Contraseña restablecida!",
    "goToLogin": "Ir al inicio de sesión",
    "invalidLinkTitle": "Enlace inválido",
    "invalidLinkBody": "Este enlace de restablecimiento es inválido o expiró.",
    "requestNewLink": "Solicitar nuevo enlace",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "errInvalidLink": "Enlace de restablecimiento inválido",
    "errMismatch": "Las contraseñas no coinciden",
    "errTooShort": "La contraseña debe tener al menos 8 caracteres",
    "errExpiredToken": "Este enlace expiró o es inválido. Solicita uno nuevo.",
    "errNetwork": "No se pudo contactar al servidor. Revisa tu conexión.",
    "errGeneric": "No se pudo restablecer. Inténtalo otra vez."
  },
  "tips": {
    "water1": "Beber agua en los 30 minutos posteriores a despertar puede mejorar la hidratación y la energía.",
    "water2": "Un vaso de agua antes de cada comida es una forma suave de adelantarse a la sed.",
    "water3": "Una rodaja de limón o unas hojas de menta convierten la hidratación en un placer.",
    "meals1": "Una ración extra de verduras al día apoya la salud intestinal y cardiovascular.",
    "meals2": "Un puñado de nueces o semillas con el desayuno mantiene tu energía estable por la mañana.",
    "meals3": "La fruta entera supera al zumo — la fibra suaviza el efecto sobre el azúcar en sangre.",
    "steps1": "Una caminata de 10 minutos tras las comidas ayuda a procesar los azúcares con más calma.",
    "steps2": "Cinco minutos de estiramiento por la mañana alivian la tensión y dan un tono tranquilo al día.",
    "steps3": "Subir las escaleras una vez al día fortalece el corazón con el paso de las semanas.",
    "sleep1": "Bajar las luces una hora antes de dormir ayuda al cuerpo a entrar en un sueño más profundo.",
    "sleep2": "Una hora fija de despertar — incluso los fines de semana — estabiliza tu ciclo de sueño.",
    "sleep3": "10 minutos de sol matinal ayudan a regular tu ritmo de sueño de forma natural.",
    "general1": "Dos minutos de respiración lenta pueden reducir el estrés y enfocar tu mente.",
    "general2": "Nota un momento de gratitud hoy — las pequeñas victorias mentales también se suman.",
    "general3": "Apareciste hoy. Ese es el hábito que hace que todos los demás sean más fáciles."
  },
  "factors": {
    "hydration": "hidratación",
    "nutrition": "nutrición",
    "movement": "movimiento",
    "sleep": "sueño"
  },
  "nutritionDeep": {
    "sectionSnapshot": "Resumen nutricional diario",
    "sectionSnapshotSubtitle": "Una mirada rápida a la hidratación, calorías y equilibrio de comidas de hoy.",
    "mealOptionsLoadFail": "No se pudieron cargar las opciones de comida",
    "prefsSaved": "¡Preferencias guardadas! Actualizando comidas...",
    "prefsSaveFail": "No se pudieron guardar las preferencias",
    "newOptionsFail": "No se pudieron cargar nuevas opciones",
    "invalidZip": "Ingresa un código postal válido de 5 dígitos",
    "noVendorsArea": "¡Aún no hay vendedores en esta zona. Estamos expandiendo cobertura!",
    "vendorsFetchFail": "No se pudieron obtener los vendedores",
    "selectVendorFirst": "Selecciona primero un vendedor de entrega",
    "removedFromCart": "Eliminado del carrito",
    "orderPlaced": "¡Pedido realizado con éxito! 🎉",
    "enterZipFirst": "Ingresa tu código postal en la sección de entrega primero",
    "mealNotAvailable": "Esta comida no está disponible para entrega en tu zona aún",
    "mealUnavailable": "Esta comida no está disponible en los vendedores cercanos",
    "vendorOptionsFail": "No se pudieron cargar las opciones de vendedor",
    "favoriteSaveFail": "No se pudo guardar el favorito",
    "removedFromFavorites": "Eliminado de favoritos",
    "favoriteRemoveFail": "No se pudo eliminar el favorito",
    "cartEmpty": "Tu carrito está vacío",
    "noMealOptions": "No hay opciones de comida disponibles",
    "loadingOptions": "Cargando opciones de comida...",
    "selectPreferences": "Selecciona tus preferencias alimentarias",
    "mealBuilder": "Crear comida",
    "myFavorites": "Mis favoritos",
    "myFavoriteMeals": "Mis comidas favoritas",
    "noFavoritesYet": "¡Aún no hay comidas favoritas!",
    "price": "Precio",
    "delivery": "Entrega",
    "deliveryFee": "Costo de entrega",
    "distance": "Distancia",
    "subtotal": "Subtotal",
    "total": "Total",
    "orderNumber": "Número de pedido",
    "vendor": "Vendedor",
    "totalAmount": "Total",
    "estimatedDelivery": "Entrega estimada",
    "whyThisMeal": "Por qué este plato",
    "selectThisMeal": "Elegir este plato",
    "swapMeal": "Cambiar plato",
    "orderThisMeal": "Pedir este plato",
    "notAvailableNearYou": "No disponible cerca de ti",
    "tryAdjustingPrefs": "Ajusta tus preferencias alimentarias para ver sugerencias",
    "myMealPlanSummary": "Mi plan de comidas",
    "saveCompletePlan": "Guardar plan completo",
    "yourFoodPreferences": "Tus preferencias alimentarias",
    "editPreferences": "Editar preferencias",
    "healthyMealDelivery": "Entrega de comidas saludables",
    "enableDelivery": "Activar entrega",
    "enterZipCode": "Ingresa tu código postal para ver comidas disponibles",
    "savePreferences": "Guardar preferencias",
    "quickAccessSavedMeals": "Acceso rápido a tus comidas guardadas",
    "saveMealsFromBuilder": "Guarda comidas desde la pestaña Crear",
    "chooseVendor": "Elige un vendedor para pedir esta comida",
    "yourCart": "Tu carrito",
    "addMealsToStart": "Agrega comidas desde las opciones de abajo",
    "orderPlacedDesc": "Tu pedido de comida saludable se realizó con éxito",
    "continueShopping": "Seguir comprando",
    "trackOrder": "Seguir pedido",
    "healthyStoresTitle": "Tiendas saludables y mercados de bienestar cercanos",
    "healthyStoresIntro": "Tipos de establecimientos con opciones culturales en tu zona — para referencia, no para envío.",
    "healthyStoresGuidanceTitle": "Guía para compras saludables",
    "healthyStoresDisclaimer": "HealthLoop ofrece inspiración para un estilo de vida saludable y compras nutritivas; esto no constituye orientación médica ni nutricional.",
    "healthyStores": {
      "organic": {
        "type": "Tiendas de productos orgánicos",
        "description": "Productos frescos sin pesticidas y alimentos básicos mínimamente procesados.",
        "tags": [
          "Alimentos integrales",
          "Productos frescos"
        ]
      },
      "farmers": {
        "type": "Mercados de agricultores",
        "description": "Frutas y verduras locales de temporada, directo de los productores.",
        "tags": [
          "Local",
          "De temporada"
        ]
      },
      "african": {
        "type": "Tiendas de productos africanos",
        "description": "Ñame, plátano macho, vegetales de hoja y productos básicos de África occidental y oriental.",
        "tags": [
          "Cultural",
          "Productos frescos"
        ]
      },
      "caribbean": {
        "type": "Mercados de alimentos caribeños",
        "description": "Callaloo, yuca, ají chombo, ackee, fruta del pan y básicos de las islas.",
        "tags": [
          "Cultural",
          "Alimentos integrales"
        ]
      },
      "asian": {
        "type": "Supermercados de vegetales asiáticos",
        "description": "Bok choy, daikon, raíz de loto, tofu, hierbas frescas y básicos panasiáticos.",
        "tags": [
          "Cultural",
          "Productos frescos"
        ]
      },
      "halal": {
        "type": "Mercados de alimentos Halal",
        "description": "Proteínas magras con certificación Halal, productos frescos y especias tradicionales.",
        "tags": [
          "Halal",
          "Cultural"
        ]
      },
      "mediterranean": {
        "type": "Mercados de productos mediterráneos",
        "description": "Aceite de oliva, legumbres, hierbas frescas, granos integrales y básicos del Mediterráneo.",
        "tags": [
          "Cultural",
          "Alimentos integrales"
        ]
      },
      "wellness": {
        "type": "Tiendas enfocadas en el bienestar",
        "description": "Alimentos integrales seleccionados, opciones a base de plantas y productos de etiqueta limpia.",
        "tags": [
          "Alimentos integrales",
          "Basado en plantas"
        ]
      }
    },
    "healthyShoppingTips": [
      "Recorre primero el perímetro: los productos frescos, proteínas magras y alternativas lácteas suelen estar en los bordes.",
      "Prioriza alimentos integrales de un solo ingrediente sobre los productos altamente procesados.",
      "Elige productos locales de temporada: suelen ser más frescos, económicos y nutritivos.",
      "Pregunta a los vendedores sobre el origen y los métodos de cultivo; muchos compartirán esa información con gusto."
    ]
  },
  "messages": {
    "success": "¡Éxito!",
    "error": "Error",
    "saved": "Guardado exitosamente",
    "updated": "Actualizado exitosamente",
    "deleted": "Eliminado exitosamente",
    "confirmDelete": "¿Estás seguro de que quieres eliminar esto?",
    "networkError": "Error de red. Por favor, intenta de nuevo.",
    "somethingWrong": "Algo salió mal",
    "failedToLoad": "Error al cargar el panel",
    "offlineMode": "Modo sin conexión - mostrando datos limitados",
    "locationDenied": "Acceso a ubicación denegado. Verifica la configuración del navegador para habilitarlo.",
    "locationUnavailable": "Información de ubicación no disponible",
    "locationTimeout": "Solicitud de ubicación agotada. Por favor, intenta de nuevo.",
    "locationError": "No se puede acceder a la ubicación",
    "locationGranted": "¡Acceso a ubicación concedido! Mostrando opciones cercanas",
    "locationNotSupported": "Servicios de ubicación no admitidos por tu navegador",
    "requestingLocation": "Solicitando acceso a ubicación..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Rastreador de Salud Preventiva",
    "educationHub": "Centro de Educación",
    "engagementWidget": "Widget de Compromiso",
    "wellnessCheckIn": "Registro de Bienestar",
    "todaysMetrics": "Métricas de Hoy",
    "bloodPressure": "Presión Arterial",
    "heartRate": "Frecuencia Cardíaca",
    "weight": "Peso",
    "sleep": "Sueño",
    "waterIntake": "Consumo de Agua",
    "exercise": "Ejercicio",
    "logMetric": "Registrar Métrica",
    "viewHistory": "Ver Historial"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Recordatorios de Salud",
    "subtitle": "Mantente al día con notificaciones de salud personalizadas",
    "breakfast": "Recordatorio de Desayuno",
    "lunch": "Recordatorio de Almuerzo",
    "dinner": "Recordatorio de Cena",
    "water": "Consumo de Agua",
    "movement": "Pausa de Movimiento",
    "sleep": "Recordatorio de Sueño",
    "wellness": "Registro de Bienestar",
    "healthLogging": "Registro de Salud",
    "annualCheckup": "Chequeo Anual",
    "enable": "Activar",
    "disable": "Desactivar",
    "customize": "Personalizar Hora",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "Únete a HealthLoop",
    "subtitle": "Comienza hoy tu camino de salud preventiva",
    "fullName": "Nombre completo",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "createAccount": "Crear cuenta",
    "haveAccount": "¿Ya tienes cuenta?",
    "signIn": "Iniciar sesión",
    "creating": "Creando cuenta...",
    "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
    "setupBiometric": "Configurar inicio biométrico",
    "setupBiometricDesc": "Usa tu huella, Face ID o Windows Hello para un acceso más rápido y seguro",
    "setupNow": "Configurar ahora",
    "skipForNow": "Ahora no",
    "settingUp": "Configurando...",
    "benefit1": "Sin contraseñas que recordar",
    "benefit2": "Mayor seguridad con biometría",
    "benefit3": "Inicia sesión con un toque o una mirada",
    "biometricPrivacy": "Tus datos biométricos nunca salen de tu dispositivo",
    "biometricSuccess": "¡Inicio biométrico configurado! 🎉",
    "biometricFailed": "No se pudo configurar el inicio biométrico. Puedes hacerlo después en ajustes.",
    "biometricSetupLater": "Puedes configurar el inicio biométrico más tarde en tu perfil"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
